import { type UserLangEnum } from "@/config/apiClient.types";

export const formatQuantity = ({
  quantity,
  locale = "fr",
}: {
  quantity: number;
  locale: UserLangEnum | undefined;
}): string => {
  return new Intl.NumberFormat(locale, {
    style: "decimal",
  }).format(quantity);
};
